import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import * as _ from 'lodash';
import { result } from 'lodash';
import { UserDto } from 'projects/shared/src/lib/models/User';
import { AccountService } from 'projects/shared/src/lib/services/account.service';
import { NotificationService } from 'projects/shared/src/lib/services/notification.service';
import { OAuthServiceService } from 'projects/shared/src/lib/services/o-auth-service.service';
import { TenantService } from 'projects/shared/src/lib/services/tenant.service';
import { TranslateService } from 'projects/shared/src/lib/services/translate.service';
import { DeleteUserDialogComponent } from '../delete-user-dialog/delete-user-dialog.component';
import { TenantDto } from 'projects/shared/src/lib/models/TenantDto';

@Component({
  selector: 'users-button-renderer',
  templateUrl: './users-button-renderer.component.html',
  styleUrls: ['./users-button-renderer.component.scss']
})
export class UsersButtonRendererComponent implements ICellRendererAngularComp {

  params: any;

  rowUserData!: any[];
  icon_edit!:string;
  icon_delete!:string;  
  icon_view!:string;

  routerLinkEditUser!:string;
  routerLinkViewUser!:string;

  isFromSM = false;
  //_db!:string;
  //tenant: TenantDto;

  constructor(
    //private tenantDto: TenantDto,
    public dialog: MatDialog,    
    private oauthService: OAuthServiceService,
    private tenantService:TenantService,
    private accountService: AccountService,
    public translate: TranslateService,
    private notificationService: NotificationService
  ) {
      // this.tenant = this.tenantDto;
      // console.log("==============> constructor tenant = ", this.tenant);
   }

  refresh(params: ICellRendererParams): boolean {
    const dataParams = params.colDef?.cellRendererParams;
    this.routerLinkViewUser = _.isFunction(dataParams.routerLinkViewUser) ? dataParams.routerLinkViewUser(params) : _.get(params.data, dataParams.routerLinkViewUser);
    this.routerLinkEditUser = _.isFunction(dataParams.routerLinkEditUser) ? dataParams.routerLinkEditUser(params) : _.get(params.data, dataParams.routerLinkEditUser);
    return false;
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.rowUserData = [this.params.node.data];
    //console.log("===============> User Button Renderer - row data = ", this.rowUserData);

    this.isFromSM = this.tenantService.currentTenantName === 'SM' ? true : false;
    this.icon_edit = this.params.icon_edit || null;
    this.icon_view = this.params.icon_view || null;
    this.icon_delete = this.params.icon_delete || null;
   
    this.routerLinkViewUser = this.params.routerLinkViewUser || null;
    this.routerLinkEditUser = this.params.routerLinkEditUser || null;

    this.oauthService.userData.subscribe({
      next: (data) => {
        if (typeof data != undefined && data != null) {
          let userRoles = data.role as Array<string>;
          userRoles.forEach((dbrole: string) => {
            if (dbrole === 'admin') {
              // this._db = dbrole;
             }
          });
        }
      }
    });
    this.refresh(params);
  }

  lockUser() {
    const rowData = [this.params.node.data];  
    let userDto = new UserDto;

    //console.log("===============> lock user - row data = ", rowData[0]);

    userDto.id = rowData[0].id;
    userDto.userName = rowData[0].userName;
    userDto.email = rowData[0].email;
    userDto.emailConfirmed = rowData[0].emailConfirmed;
    userDto.first_Name = rowData[0].first_Name;
    userDto.last_Name = (rowData[0].userName == ' (not confirmed)') ? rowData[0].userName : rowData[0].last_Name;  
    userDto.phoneNumber = rowData[0].phoneNumber;
    userDto.phoneNumberConfirmed = rowData[0].phoneNumberConfirmed;
    userDto.twoFactorEnabled = rowData[0].twoFactorEnabled;
    userDto.lockoutEnabled = true;
    userDto.lockoutEnd = new Date("9999-12-31T23:59:59.999Z");
    userDto.accessFailedCount = rowData[0].accessFailedCount;
    userDto.userRoles = rowData[0].userRoles;
    userDto.isDemoUser = rowData[0].isDemoUser;
    userDto.createdWhen = rowData[0].createdWhen;

    //console.log("===============> lock user - userDto = ", userDto);

    this.tenantService.updateUser(this.tenantService.tempTenantName, userDto).subscribe({
      next:() => {
        this.tenantService.setUserTenancyLocked(this.tenantService.tempTenantName, this.tenantService.tempTenantId, userDto.id, true).subscribe({
          next:() => {
          this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `Benutzer wurde für diesen Mandanten gesperrt`);
          this.params.api.refreshInfiniteCache();
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `Sperre konnte nicht für diesen Mandanten vermerkt werden`)
        });
     },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `Benutzer konnte nicht für diesen Mandanten gesperrt werden`)
    });        
  }

  unlockUser() {
    const rowData = [this.params.node.data];  
    let userDto = new UserDto;

    userDto.id = rowData[0].id;
    userDto.userName = rowData[0].userName;
    userDto.email = rowData[0].email;
    userDto.emailConfirmed = rowData[0].emailConfirmed;
    userDto.first_Name = rowData[0].first_Name;
    userDto.last_Name = (rowData[0].userName == ' (not confirmed)') ? rowData[0].userName : rowData[0].last_Name;  
    userDto.phoneNumber = rowData[0].phoneNumber;
    userDto.phoneNumberConfirmed = rowData[0].phoneNumberConfirmed;
    userDto.twoFactorEnabled = rowData[0].twoFactorEnabled;
    userDto.lockoutEnabled = false;
    userDto.lockoutEnd = new Date();
    userDto.accessFailedCount = rowData[0].accessFailedCount;
    userDto.userRoles = rowData[0].userRoles;
    userDto.isDemoUser = rowData[0].isDemoUser;
    userDto.createdWhen = rowData[0].createdWhen;

    this.tenantService.updateUser(this.tenantService.tempTenantName, userDto).subscribe({
      next:() => {
        this.tenantService.setUserTenancyLocked(this.tenantService.tempTenantName, this.tenantService.tempTenantId, userDto.id, false).subscribe({
          next:() => {
            this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `Benutzer wurde für diesen Mandanten entsperrt`);
            this.params.api.refreshInfiniteCache();
          },
          error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `Entsperrung konnte nicht für diesen Mandanten vermerkt werden`)
        });
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `Benutzer konnte nicht für diesen Mandanten entsperrt werden`)
    });
  }

  resendInvitation() {
    const rowData = [this.params.node.data];  
    let userDto = new UserDto;
    userDto.id = rowData[0].id;
    userDto.userName = rowData[0].userName;
    userDto.email = rowData[0].email;
    userDto.emailConfirmed = rowData[0].emailConfirmed;
    userDto.first_Name = rowData[0].first_Name;
    userDto.last_Name = rowData[0].last_Name;
    let dummyPairs: string[] = [];
    this.accountService.renewUser(/*isTenantAdmin:*/ false, /*inclTGR:*/ false, /*copyUserId:*/ 'undefined', userDto, /*rolePairs*/ dummyPairs, this.tenantService.tempTenantName, this.tenantService.tempTenantId).subscribe({
      next: (user) => {
        // this.rowData.splice(2, 0, user);
        // this.rowData.push(user);            
        this.notificationService.success(`${this.translate.data["SUCCESS"]}`, "Einladung wurde erneut versendet");
        this.params.api.refreshInfiniteCache();
      },
      error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, "Benutzer existiert noch, die Einladung konnte nicht erneut versendet werden")
    });

    // this.tenantService.resendInvitation(this.tenantService.tempTenantName, this.tenantService.tempTenantId, userDto.id).subscribe({
    //   next:() => {
    //     this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `Einladung wurde erneut versendet`);
    //   },
    //   error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `Einladung konnte nicht erneut versendet werden`)
    // });
  }

  isOutOfDate(invitationDueDate: string): boolean {
    //console.log("==============> invitationDueDate: ", invitationDueDate);
    const dueDate = new Date(invitationDueDate);
    const today = new Date();
    
    const dueDateOnly = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate());
    const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    
    return dueDateOnly < todayOnly;
  }

  deleteUser() {
    const rowData = [this.params.node.data];
    
    let userDto = new UserDto;

    userDto.id = rowData[0].id;
    userDto.userName = rowData[0].userName;
    userDto.email = rowData[0].email;
    // userDto.emailConfirmed = rowData[0].emailConfirmed;
    userDto.first_Name = rowData[0].firstName;
    userDto.last_Name = rowData[0].lastName;
    // userDto.phoneNumber = rowData[0].phoneNumber;
    // userDto.phoneNumberConfirmed = rowData[0].phoneNumberConfirmed;
    // userDto.twoFactorEnabled = rowData[0].twoFactorEnabled;
    // userDto.lockoutEnabled = rowData[0].lockoutEnabled;
    // userDto.lockoutEnd = rowData[0].lockoutEnd;
    // userDto.accessFailedCount = rowData[0].accessFailedCount;
    // userDto.userRoles = rowData[0].userRoles;

    
    // beim löschen eines Users aus einem Tenant, wird der User aus dem Tenant entfernt und nicht gelöscht
    const dialogRef = this.dialog.open(DeleteUserDialogComponent, {width: '500px',data:{userDto: userDto, params: this.params} }); 
    dialogRef.afterClosed().subscribe((result:any) => {

      if(result != undefined){
      
        
          // es kann sein, dass diese Aktion vom Admin in SM ausgeführt wird, dann ist der temporäre Tenant zu nehmen
          // der temporäre Tenant wird gesetzt, wenn der Admin für einen Tenant eine Aktion ausführt,
          // aber auch, wenn man in den Tenant gewechselt hat. Dann ist der temporäre Tenant gleich dem current Tenant
          let db:string = this.tenantService.tempTenantName;
          let dbId:string = this.tenantService.tempTenantId;

          //console.log("==============> remove user from tenant:  = ", db)

          this.tenantService.deleteUser(db, dbId, result.id).subscribe({
            next:() => {
              this.notificationService.success(`${this.translate.data["SUCCESS"]}`, `${this.translate.data["USERDELETED"]}`);
              this.params.api.refreshInfiniteCache();
            },
            error: (error: any) => this.notificationService.error(`${this.translate.data["ERROR"]}`, `${this.translate.data["USERUSERDELETEDERROR"]}`)
          });

        // }
       
      }
    });    
  }
}
